module.exports = __webpack_public_path__ + "img/Best of Frankreich rot.f6d329ed.jpg";